// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 937 ? "eabe11fc" : chunkId) + "." + {"167":"4f0cfc57ce82a535","396":"bfe32f31ac79490a","555":"e4f8d57dfde4d0d0","651":"6b0a0a214e3e799c","741":"a83780b663de33f6","937":"b60dcff574eeca58"}[chunkId] + ".js";
};